import React from "react";
import styles from "./Error.module.css";
import { Link } from "react-router-dom";
import { LOGIN_PATH } from "../../router/RouteConstants";
import { useAuthenticate } from "../../hooks";

const ErrorPageNotFound = () => {
    const { auth } = useAuthenticate();

    return (
        <div className={styles.error_not_found}>
            <div>404</div>
            <div>Page Not Found</div>
            <Link className={styles.link_to_home} to={LOGIN_PATH}>
                {auth ? "Go to Dashboard Page" : "Go to Login Page"}
            </Link>
        </div>
    );
};

export default ErrorPageNotFound;
